<template>
  <div class="index">
    <vuescroll :ops="vuescrollOption">
      <banner></banner>
      <div class="content">
        <div class='breadcrumb'>
          <div class="left">
            您目前的位置：<router-link to="/index">首頁</router-link>> 公告
          </div>
          <div class="right">
            <router-link to="/index">
              <img src="@/assets/images/article/returnHome.png">
            </router-link>
          </div>
        </div>
        <div class='contentText'>
          <div class='noticeLine' v-for="notice in noticeList" @click='goPage(notice.url)'> 
            <div class='title'>[公告]{{notice.title}}</div>
            <div class='date'>{{notice.date}}</div>
          </div>
        </div>
      </div>
      <foot></foot>
    </vuescroll>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
import banner from '@/components/banner';
import foot from '@/components/foot';
export default {
  name: 'index',
  components:{
    vuescroll,banner,foot
  },
  data () {
    let tempnoticeList=[];
    for(let i=0;i<noticeList.length;i++){
      tempnoticeList.push({title:noticeList[i].title,url:noticeList[i].url,date:noticeList[i].date});
    }
    tempnoticeList=tempnoticeList.reverse();
    return {
      noticeList:tempnoticeList,
      vuescrollOption:{
        scrollPanel: {
          initialScrollY: 6.7*parseFloat(document.documentElement.style.fontSize),
        },
      }
    }
  },
  mounted(){
    // let x=window.innerWidth;
    // document.documentElement.style.fontSize = x/19.2+"px";
    // console.log(noticeList);
  },
  methods:{
    goPage(href){
      window.location.href=href;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@fullWidth:19.2rem;

@bannerHeight:872/100rem;
@contectHeight:2162/100rem;
@footHeight:174/100rem;

@googleBTWidth:326/100rem;
@iphoneBTWidth:262/100rem;
@downloadGaps:.5rem;

@newWidth:48/100rem;

@marqueImgWidth:1200/100rem;
.index{
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  overflow: hidden;
  .content{
    margin-left: 3.2rem;
    width: @fullWidth - 6.4rem;
    .breadcrumb{
      margin-top: .35rem;
      margin-bottom: .74rem;
      height:.42rem;
      .left{
        float: left;
        line-height:.42rem;
        font-size:.24rem
      }
      .right{
        float: right;
        font-size:0rem;
        img{
          width:1.32rem;
        }
      }
      a{
        color:#f56b85;
      }
    }
    .titleDiv{
      width:100%;
      height:1.66rem;
      border-top:solid .02rem #ebebeb;
      border-bottom:solid .02rem #ebebeb;
      .title{
        width:100%;
        height:.36rem;
        line-height:.36rem;
        font-size:.36rem;
        color:#ec4828;
        text-align: center;
        margin-top:.5rem;
      }
      .time{
        width:100%;
        height:.24rem;
        line-height:.24rem;
        font-size:.24rem;
        color:#68696b;
        text-align: center;
        margin-top:.18rem;
      }
    }
    .contentText{
      width:@fullWidth - 6.4rem - 2rem;
      line-height:.7rem;
      font-size:.24rem;
      color:#68696b;
      margin-left: 1rem;
      // margin-top: .8rem;
      margin-bottom: .74rem;
      float: left;
      .noticeLine{
        float: left;
        width:100%;
        border-bottom: solid .02rem #ebebeb;
        cursor:pointer;
        .title{
          float: left;
          width:75%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .date{
          float: right;
          // width:20%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/list.vue